import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';

const STATEMENT_AGING_SCHEMA = Object.freeze({
  CURRENT_DUE: 0,
  OVERDUE_1_30DAYS: 0,
  OVERDUE_31_60DAYS: 0,
  OVERDUE_61_90DAYS: 0,
  OVERDUE_91DAYS: 0,
});
const RECORD = generateSchema(STATEMENT_AGING_SCHEMA);
const KEYS: any = generateKeys(STATEMENT_AGING_SCHEMA);

export class StatementAging extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }
}
